import * as isoCountries from 'i18n-iso-countries'
import * as isoCountriesLocale from 'i18n-iso-countries/langs/en.json'
isoCountries.registerLocale(isoCountriesLocale)

export interface CountryListItem {
  key: string
  value: string
  text: string
}

export const removeRestrictedCountries = (countries: CountryListItem[], applyFilter: boolean): CountryListItem[] => {
  if (!applyFilter) {
    return countries
  }

  const restrictedCountries: string[] = [
    'Cuba',
    'Iran, The Islamic Republic of',
    'North Korea',
    'Sudan',
    'Russian Federation'
  ]

  return countries.filter((x: CountryListItem) => {
    return !restrictedCountries.includes(x.text)
  })
}

export const getCountryOptions = (applyFilter: boolean): CountryListItem[] => {
  const countryList = isoCountries.getNames('en')
  const countryOptions: CountryListItem[] = []

  const keys = Object.keys(countryList)

  for (let i = 0; i < keys.length; i++) {
    countryOptions.push({ key: keys[i], value: keys[i], text: countryList[keys[i]] })
  }

  const countries: CountryListItem[] = removeRestrictedCountries(countryOptions, applyFilter)

  return countries
}
